import { useNextHigherPlan } from "v2/hooks/billing/pricing-options/useNextHigherPlan";


export function useAutoUpgradePrompt() {
  const { nextHigherPlan } = useNextHigherPlan();

  if (nextHigherPlan) {
    return "Auto-upgrade to " + nextHigherPlan.planName + " plan";
  } else {
    return "Auto-upgrade";
  }
}
